import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	forwardRef,
	HostBinding,
	inject,
	Input,
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR, UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";

const INPUT_CONTROL_ACCESSOR = {
	provide: NG_VALUE_ACCESSOR,
	useExisting: forwardRef(() => TextAreaInputComponent),
	multi: true,
};

@Component({
	selector: "pv-text-area",
	styleUrls: ["input.component.scss"],
	providers: [INPUT_CONTROL_ACCESSOR],
	templateUrl: "./input.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class TextAreaInputComponent implements ControlValueAccessor {
	private readonly cdRef = inject(ChangeDetectorRef);
	private readonly formBuilder = inject(UntypedFormBuilder);

	@Input() label: string;
	@Input() placeholder: string;
	@Input() inputClass: string;
	@Input() help: string;
	@Input() required = true;

	@HostBinding("class.disabled") disabled = false;

	form: UntypedFormGroup = this.formBuilder.group({
		value: [""],
	});

	private onTouch = () => {}; // eslint-disable-line @typescript-eslint/no-empty-function
	private onModelChange = (_: unknown) => {};

	writeValue(value: string) {
		if (value) {
			this.form.setValue({ value });
		} else {
			this.form.reset();
		}
		this.cdRef.markForCheck();
	}

	registerOnChange(fn: (v: unknown) => void) {
		this.onModelChange = fn;
	}

	registerOnTouched(fn: () => void) {
		this.onTouch = fn;
	}

	setDisabledState(isDisabled: boolean) {
		this.disabled = isDisabled;
		if (isDisabled) {
			this.form.disable();
		} else {
			this.form.enable();
		}
		this.cdRef.markForCheck();
	}

	onChange(value: string) {
		this.form.setValue({ value });
		this.onModelChange(value);
		this.onTouch();
	}

	onTouched() {
		this.onTouch();
	}
}
